module.exports = __webpack_public_path__ + "static/media/top-wave.c6411670.svg";